module.exports = "<div [class.loader-hidden]=\"!show\">\n  <div class=\"loader-overlay\">\n    <div>\n    </div>\n\n    <div class=\"loader-logo\">\n      <img class=\"logo-img\" src=\"assets/loader.gif\" alt=\"\" />\n    </div>\n\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main